/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import AuthContext from "store/auth-context";
import OpenTicketsList from "pages/tickets/open-tickets-list";
import TicketDetails from "pages/tickets/ticketDetails";
import ClosedTicketsList from "pages/tickets/closed-tickets-list";
import TaskDetails from "pages/tickets/tasks/task-details";
import JobCards from "pages/tickets/jobCards";
import SelfAssignedTickets from "pages/tickets/dispatcherTickets/self-assigned-tickets-list";
import RoutesManagement from "pages/routesManagement";
import Profile from "pages/profile";
import ChangePassword from "pages/changePassword";
import { StatusContext } from "pages/tickets/constants";
import RouteListener from "components/routeListener";
import CCAAwaitingTicketsList from "pages/tickets/callCenterAgentTickets/awaiting-tickets-list";
import CCAResolvedTicketsList from "pages/tickets/callCenterAgentTickets/resolved-tickets-list";
import CCAVaultedTicketsList from "pages/tickets/callCenterAgentTickets/vault-access-tickets-list";
import CCACancelledTicketsList from "pages/tickets/callCenterAgentTickets/cancelled-tickets-list";
import Header from "layout/header";
import AllTicketsList from "pages/tickets/all-tickets";
import { defaultFilters, FiltersContext } from "store/filters-context";
import DispatcherGunneboTicketsList from "pages/tickets/dispatcherTickets/gunnebo-tickets";
import DispatcherNonGunneboTicketsList from "pages/tickets/dispatcherTickets/non-gunnebo-tickets";
import CCACashTicketsList from "pages/tickets/callCenterAgentTickets/cash-tickets-list";
import AssignedTicketsList from "pages/tickets/assigned-tickets";
import Reports from "pages/reports";
import Dashboard from "pages/dashboard";
import DashboardDetail from "pages/dashboard/detail-page";
import CreateTicket from "../pages/tickets/createTicket";
import { PATHS } from "./paths";
import BulkOperations from "pages/tickets/bulkOperations";
import CreateFacilitiesTicket from "pages/tickets/createTicket/create-facilities";
import CreateCustomerComplaint from "pages/tickets/createTicket/customer-complaint";
import CreateRemoteSupportTicket from "pages/tickets/createTicket/remote-support";
import CreateCustomerServiceTicket from "pages/tickets/createTicket/create-customer-service";
import CreateEtisalatThirdPartyTicket from "pages/tickets/createTicket/create-etisalat-third-party";
import CCAResolvedCallsList from "pages/tickets/callCenterAgentCalls/resolved-calls";
import CCAOpenCallsList from "pages/tickets/callCenterAgentCalls/open-calls";
import CCAClosedCallsList from "pages/tickets/callCenterAgentCalls/closed-calls";
import CCACancelledCallsList from "pages/tickets/callCenterAgentCalls/cancelled-calls";
import CCAAssignedCallsList from "pages/tickets/callCenterAgentCalls/assigned-calls";
import CCAAllCallsList from "pages/tickets/callCenterAgentCalls/all-calls";
import CCACashCallsList from "pages/tickets/callCenterAgentCalls/cash-calls";
import CCAMyCallsList from "pages/tickets/callCenterAgentCalls/my-calls";
import CreateUnusualEventTicket from "pages/tickets/createTicket/create-unusual-events";
import CCAAllServiceAndNonServiceCalls from "pages/tickets/all-calls";

const routes = [
  {
    path: "",
    element: <Dashboard />,
    isPrivate: 1,
  },
  {
    path: "/",
    element: <Dashboard />,
    isPrivate: 1,
  },
  {
    path: "*",
    element: <Dashboard />,
    isPrivate: 1,
  },
  {
    path: PATHS.dashboard,
    element: <Dashboard />,
    isPrivate: 1,
  },
  {
    path: PATHS.dashboardDetail,
    element: <DashboardDetail />,
    isPrivate: 1,
  },
  {
    path: PATHS.createTicket,
    element: <CreateTicket />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createTicket}/:ticketId`,
    element: <CreateTicket />,
    isPrivate: 1,
  },
  {
    path: PATHS.createFacilityTickets,
    element: <CreateFacilitiesTicket />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createFacilityTickets}/:ticketId`,
    element: <CreateFacilitiesTicket />,
    isPrivate: 1,
  },
  {
    path: PATHS.createCustomerComplaint,
    element: <CreateCustomerComplaint />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createCustomerComplaint}/:ticketId`,
    element: <CreateCustomerComplaint />,
    isPrivate: 1,
  },
  {
    path: PATHS.createRemoteSupportRequest,
    element: <CreateRemoteSupportTicket />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createRemoteSupportRequest}/:ticketId`,
    element: <CreateRemoteSupportTicket />,
    isPrivate: 1,
  },

  {
    path: PATHS.createCustomerService,
    element: <CreateCustomerServiceTicket />,
    isPrivate: 1,
  },

  {
    path: `${PATHS.createCustomerService}/:ticketId`,
    element: <CreateCustomerServiceTicket />,
    isPrivate: 1,
  },
  {
    path: PATHS.createEtisalatThirdParty,
    element: <CreateEtisalatThirdPartyTicket />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createEtisalatThirdParty}/:ticketId`,
    element: <CreateEtisalatThirdPartyTicket />,
    isPrivate: 1,
  },
  {
    path: PATHS.createUnusualEvent,
    element: <CreateUnusualEventTicket />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.createUnusualEvent}/:ticketId`,
    element: <CreateUnusualEventTicket />,
    isPrivate: 1,
  },

  {
    path: PATHS.bulkOperation,
    element: <BulkOperations />,
    isPrivate: 1,
  },
  {
    path: PATHS.allServiceAndNonServiceCalls,
    element: <CCAAllServiceAndNonServiceCalls />,
    isPrivate: 1,
  },
  {
    path: PATHS.selfAssignedTickets,
    element: <SelfAssignedTickets />,
    isPrivate: 1,
  },
  {
    path: PATHS.allTickets,
    element: <AllTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.assignedTickets,
    element: <AssignedTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.cashTickets,
    element: <CCACashTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.openTickets,
    element: <OpenTicketsList />,
    isPrivate: 1,
  },

  {
    path: PATHS.vaultAccessTickets,
    element: <CCAVaultedTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.closedTickets,
    element: <ClosedTicketsList />,
    isPrivate: 1,
  },

  {
    path: PATHS.cancelledTickets,
    element: <CCACancelledTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.awaitingTickets,
    element: <CCAAwaitingTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.resolvedTickets,
    element: <CCAResolvedTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.allCalls,
    element: <CCAAllCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.myCalls,
    element: <CCAMyCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.openCalls,
    element: <CCAOpenCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.cashCalls,
    element: <CCACashCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.resolvedCalls,
    element: <CCAResolvedCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.assignedCalls,
    element: <CCAAssignedCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.closedCalls,
    element: <CCAClosedCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.cancelledCalls,
    element: <CCACancelledCallsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.gunnebo,
    element: <DispatcherGunneboTicketsList />,
    isPrivate: 1,
  },
  {
    path: PATHS.nonGunnebo,
    element: <DispatcherNonGunneboTicketsList />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.jobCards}/:ticketId`,
    element: <JobCards />,
    isPrivate: 1,
  },
  {
    path: `${PATHS.ticketDetails}/:ticketId`,
    element: <TicketDetails />,
    isPrivate: 1,
  },

  {
    path: `${PATHS.taskDetails}/:requestId`,
    element: <TaskDetails />,
    isPrivate: 1,
  },

  {
    path: "/routes",
    element: <RoutesManagement />,
    isPrivate: 1,
  },
  {
    path: PATHS.profile,
    element: <Profile />,
    isPrivate: 1,
  },
  {
    path: PATHS.changePassword,
    element: <ChangePassword />,
    isPrivate: 1,
  },
  {
    path: PATHS.reports,
    element: <Reports />,
    isPrivate: 1,
  },
];

export function AppRoutes() {
  const [ticket, setTicket] = useState("open");
  const [filters, setFilters] = useState({
    ...defaultFilters,
  });
  const authCtx = useContext(AuthContext);
  useEffect(() => {
    if (window.self !== window.top) {
      window.addEventListener("message", messageHandler);
    } else {
      const sessionData = JSON.stringify({
        redirectUrl: window.location.pathname,
      });
      const encodedData = encodeURIComponent(sessionData);

      window.location.href = `${process.env.REACT_APP_ADMIN}/?sessionData=${encodedData}`;
    }
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  const messageHandler = (event) => {
    if (event.origin === process.env.REACT_APP_ADMIN) {
      console.log("event", event);
      console.log("env", process.env.REACT_APP_ADMIN);

      if (event.data.auth) {
        const _data = JSON.parse(event.data.auth);
        authCtx.login(
          _data.accessToken,
          _data.accessTokenExpiry,
          _data.refreshToken,
          _data.refreshTokenExpiry
        );
      } else {
        // eslint-disable-next-line no-console
        console.log("Not authenticated");
      }
    }
  };

  const updateTicket = useCallback((response) => {
    setTicket(JSON.parse(JSON.stringify(response)));
  }, []);

  const ticketContext = useMemo(
    () => ({
      status: ticket,
      setStatus: updateTicket,
    }),
    [ticket, updateTicket]
  );
  const updateFilter = useCallback((response) => {
    setFilters({ ...response });
  }, []);

  const filtersContext = useMemo(
    () => ({
      filters: { ...filters },
      setFilters: updateFilter,
    }),
    [filters, updateFilter]
  );
  return (
    <StatusContext.Provider value={ticketContext}>
      <FiltersContext.Provider value={filtersContext}>
        <BrowserRouter>
          {authCtx.isLoggedIn ? (
            <>
              <RouteListener />
              <Header />
              <div className="content-container">
                <Routes>
                  {routes.map((route) => {
                    return (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                      />
                    );
                  })}
                </Routes>
              </div>
            </>
          ) : (
            <Routes>
              <Route path="/" element={<>UnAuthorized</>} />
            </Routes>
          )}
        </BrowserRouter>
      </FiltersContext.Provider>
    </StatusContext.Provider>
  );
}
